import { inject } from 'inversify';
import { urlMaker } from '@core/utils';
import { IRepo, IRepoResponse } from '@core/repo';
import { HttpClientType } from '@core/http';
import type { IHttpClient } from '@core/http';
import { bind } from '@infra/container';

import { IObject } from '../interfaces';

export type IGetObjectsRepoResponse = IRepoResponse<200, { data: IObject[]; total: number }> | IRepoResponse<400 | 500, string>;

export type IGetObjectsRepo = IRepo<[any], IGetObjectsRepoResponse>;

export const GetObjectsRepoType = Symbol.for('GetObjectsRepo');

@bind(GetObjectsRepoType)
export class GetObjectsRepo implements IGetObjectsRepo {
  constructor(@inject(HttpClientType) private readonly httpClient: IHttpClient) {}

  async execute(query: object) {
    try {
      const result = await this.httpClient.get({ url: urlMaker('/objects', { sort_column: 'id', sort_order: 'desc', ...query, relations: ['mobile_groups', 'region', 'status'] }) });
      if (result.status === 200) {
        const data: IObject[] = result.data.data.data;
        const total: number = result.data.data.total;
        return {
          status: 200 as 200,
          response: {
            data,
            total,
          },
        };
      } else {
        return {
          status: 400 as 400,
          response: 'Məlumatlar əldə edilə bilmədi',
        };
      }
    } catch (e) {
      return {
        status: 500 as 500,
        response: 'Şəbəkə ilə əlaqə qurula bilmədi',
      };
    }
  }
}
